import { render, staticRenderFns } from "./tabInternalProject.vue?vue&type=template&id=0e22fd7c&"
import script from "./tabInternalProject.vue?vue&type=script&lang=ts&"
export * from "./tabInternalProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports